import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space, Typography } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminHolidaysTableColumns";
import moment from "moment-jalaali";

function AdminHolidaysListTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
}) {
  const [tableData, setTableData] = useState([]);
  const { getHolidaysCount: count, getHolidays: holidays } = data;

  useEffect(() => {
    const initialTableData = [];
    holidays.map((holiday) => {
      const { id, createdAt, workAt, startTime, endTime, contract, user } =
        holiday;
      initialTableData.push({
        key: id,
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        workAt: moment(workAt).format("jYYYY/jMM/jDD"),
        time: (
          <p>
            از {startTime} تا {endTime}
          </p>
        ),
        contract,
        user: user?.name ? user?.name : user?.mobile,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id)}>
              <EyeOutlined />
            </a>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [holidays]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 600 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdminHolidaysListTable;
